import React from "react";

import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";

import TableReact, { SelectColumnFilter } from "../../components/table/Table";
import { formatDateTime } from "../../helper/formatter.js";
import _ from "lodash";

const Talonario = () => {
    const tipocomprobantes = useSelector((state) => state.tipocomprobantes.items) || [];
    const talonarios = useSelector((state) => state.talonario.items);

    const columns = React.useMemo(
        () => [
            {
                Header: "SERIE",
                accessor: "serie",
                Cell: ({ row }) => (
                    <Link to={"/parametros/talonario/datos_talonario/" + (row.original?.id || "-")} className="fw-bold">
                        {row.original?.serie}
                    </Link>
                ),
                canGroupBy: false,
            },
            {
                Header: "Tipo Comprobante",
                accessor: "tipo_comprobante",
                Filter: SelectColumnFilter,
                canGroupBy: false,
            },
            {
                Header: "Proximo correlativo",
                accessor: "proximo_correlativo",
                canGroupBy: false,
            },
            {
                Header: "Ultimo Correlativo",
                accessor: "ultimo_correlativo",
                canGroupBy: false,
            },
            {
                Header: "Activo",
                accessor: "activo",
                Cell: ({ row }) => (row.original?.activo ? "SI" : "NO"),
                canGroupBy: false,
            },
            {
                Header: "Predeterminado",
                accessor: "predeterminado",
                Cell: ({ row }) => (row.original?.predeterminado ? "SI" : "NO"),
                canGroupBy: false,
            },
            {
                Header: "Ult. Modificacion",
                accessor: "updatedAt",
                Cell: ({ row }) => formatDateTime(row.original?.updatedAt),
                canGroupBy: false,
            },
        ],
        [tipocomprobantes]
    );

    const data = React.useMemo(
        () => _.map(talonarios, (e) => ({ ...e, ["tipo_comprobante"]: tipocomprobantes[e.tipoComprobanteId]?.name || "" })),
        [talonarios]
    );

    return (
        <Panel>
            <PanelHeader>Listado de talonarios registrados</PanelHeader>
            <PanelBody>
                <div className="d-flex flex-wrap">
                    <Link type="button" className="btn btn-green me-1 mb-1" to="/parametros/talonario/datos_talonario/0">
                        <i className="fa fa-plus"></i> Agregar talonario
                    </Link>
                </div>
            </PanelBody>
            <TableReact columns={columns} data={data} selection={false} />
        </Panel>
    );
};

export default Talonario;
